import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BET_ON_ACTION_FREE_MODE_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>(
  'betOnActionFreeModeEnabled',
  {
    factory: () => true
  }
);
